/* Instruments */
import { combineReducers } from '@reduxjs/toolkit';

import {
  featureControlSlice,
  navigationSlice,
  playerMetaSlice,
  policySlice,
  pollSlice,
  timestampSlice,
} from './slices';

export const reducer = combineReducers({
  timestampReducer: timestampSlice.reducer,
  playerMetaReducer: playerMetaSlice.reducer,
  navigationReducer: navigationSlice.reducer,
  featureControlReducer: featureControlSlice.reducer,
  policyReducer: policySlice.reducer,
  pollSlice: pollSlice.reducer,
});
